














































import { Component, Prop, Watch, Provide } from 'vue-property-decorator'
import { BaseForm } from '@/services/BaseForm'
import { IFormOption } from '@/components/form/FieldTypes'

@Component
export default class Form extends BaseForm<any> {
  @Provide('formName') public formName = (this.$parent as any).formName
  @Prop({ default: null }) protected header!: string
  @Prop({ default: [], required: true, type: Array }) protected options!: IFormOption[]
  @Prop({ default: false }) protected isReadOnly!: boolean

  @Watch('form', { deep: true })
  public onUpdateForm(data: { [key: string]: any }) {
    this.$emit('update', data)
  }
}
